import { TdCurrencyComponent } from './table-cells/currency/currency.component';

export const CB_TABLE_EXPORTS = [
    TdCurrencyComponent,
];
